import { Box } from "theme-ui";

export default function ForwardSlashIcon(props) {
  return (
    <Box
      as="svg"
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 0H12L1 24H0L11 0Z" fill="#4D4D4D" />
    </Box>
  );
}
